//
//
//
//
//
//
//
//
//
//
//
//
//
//

import _ from 'lodash';
import moment from 'moment';
import ListView from './list-view.vue';

export default {
  name: 'TopicBoard',
  data() {
    return {
      // We create separate TopicBoard for each layout (it is cached so that
      // switching between layouts is fast), so this only has to be calculated
      // once. In fact, we *don't want* this to be a computed property, because
      // it would keep updating in the background even for component instances
      // that are inactive at the moment.
      layoutId: this.$route.params.layoutId,
      customizable: this.$route.params.layoutId.startsWith("layout:"),
    };
  },
  components: {
    ListView,
  },
  computed: {
    layout() {
      if (this.layoutId === 'layout:all-subtaskOf') {
        return this.getDefaultLayout();
      }
      const prefix = this.layoutId.split(':')[0];
      if (prefix === "list") {
        return [this.layoutId];
      }
      const doc = this.$reactiveCache.docs[this.layoutId]
      if (doc) {
        if (doc.type === "list" || doc.type === "period") {
          return [this.layoutId];
        }
        return doc.layout.flat()
      } else {
        console.error(`Couldn't find layout with ID "${this.layoutId}"`)
        // TODO: differentiate between case of deleted layout and create-in-progress
        return []
      }
    },
    panels() {
      const result = [];
      for (const key of this.layout) {
        const doc = this.$reactiveCache.docs[key]
        if (!doc) {
          console.error(`Requested item "${key}" does not exist.`)
          continue;
        }
        const pClass = key.split(':')[0]
        if(doc.groupByTags) {
          const sections = [];
          for (const label of this.$root.reactiveLabels) {
            const tasks = doc.getChildren().filter((t) => this.hasLabel(t, label));
            sections.push({
              class: pClass,
              key,
              title: `${doc.name} - ${label.name} label`,
              type: 'current',
              relation: doc.relation,
              tasks,
              couch: doc.couch,
              doc,
              special: true,
              labelFilter: label._id,
            })
          }
          const unlabeledtasks = doc.getChildren().filter(this.hasNoLabels);
          sections.push({
            class: pClass,
            key,
            title: `${doc.name} - no label`,
            type: 'current',
            relation: doc.relation,
            tasks: unlabeledtasks,
            couch: doc.couch,
            doc,
            special: true,
            labelFilter: 'noLabel',
          })
          result.push({
            key,
            icon: 'assignment',
            text: doc.name,
            type: pClass,
            sections: sections
          })
        } else {
          const tasks = doc.getChildren().filter(this.isCurrent);
          result.push({
            key,
            icon: 'assignment',
            text: doc.name,
            type: pClass,
            sections: [{
              class: pClass,
              key,
              title: doc.name,
              type: 'current',
              relation: doc.relation,
              tasks,
              couch: doc.couch,
              doc,
            }]
          })
        }
      }
      return result;
    },
    centered() {
      return this.layoutId.startsWith("list:");
    }
  },
  methods: {
    isCurrent(item) {
      if (!!item.doneAtTimestampMs
          && item?.plannedFor?.parentClass
          && item.plannedFor.parentClass !== "list"
        ) {
        const startMoment = moment(item.plannedFor.parentKey)
        let endMoment;
        switch (item.plannedFor.parentClass) {
          case 'day': endMoment = startMoment; break
          case 'week': endMoment = startMoment.add(6, 'days'); break
          case 'month': endMoment = startMoment.add(1, 'month').subtract(1, 'days'); break
        }
        if (endMoment < moment().startOf('day')) {
          return false;
        }
      }
      return true
    },
    hasLabel(item, label) {
      return item.labels && item.labels.includes(label._id);
    },
    hasNoLabels(item) {
      return !item.labels || item.labels.length === 0;
    },
    getDefaultLayout() {
      return this.$root.subtaskOfLists.map(list => list._id)
    }
  },
  created() {
    performance.mark('topicboard start')
  },
  mounted() {
    performance.mark('topicboard end')
    performance.measure('building topicboard', 'topicboard start', 'topicboard end');
  },
};
